import React, { useState, useEffect } from 'react';
import { Button, Card, CardBody, CardHeader, Switch, Divider, Chip, Spinner } from '@heroui/react';
import { db } from '../../Firebase/firebase';
import swal from 'sweetalert';
import useAuth from '../Helpers/useAuth';
import { addDoc, collection, doc, getDocs, onSnapshot, query, where } from 'firebase/firestore';

const SistemaPagos = () => {
  
  const [productos, setProductos] = useState([]);
  const [suscripciones, setSuscripciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [procesandoPago, setProcesandoPago] = useState(false);
  const [allowPromotionCodes, setAllowPromotionCodes] = useState(false);
  const { currentUser ,user} = useAuth();

  // Cargar productos disponibles
  useEffect(() => {
    console.log(user)
    if (!user) return;

    const cargarProductos = async () => {
      try {
        const productosSnapshot = await getDocs(query(collection(db,"products"),where("active","==",true)))

        const productosConPrecios = await Promise.all(
          productosSnapshot.docs.map(async (productDoc) => {
            console.log(productDoc.data())
            const productData = productDoc.data();
            const preciosSnapshot = await getDocs(query(collection(db,"products",productDoc.id,"prices")))
            
            const precios = preciosSnapshot.docs.map(precioDoc => ({
              id: precioDoc.id,
              ...precioDoc.data()
            }));

            return {
              id: productDoc.id,
              ...productData,
              prices: precios
            };
          })
        );

        setProductos(productosConPrecios);
      } catch (error) {
        console.error('Error cargando productos:', error);
        swal('Error', 'No se pudieron cargar los productos', 'error');
      } finally {
        setLoading(false);
      }
    };

    cargarProductos();
  }, [user]);

  // Escuchar suscripciones activas del usuario
  useEffect(() => {
    if (!user) return;

    const unsubscribeSuscripciones = onSnapshot(query(collection(db,"customers",user.uid,"subscriptions"),where("status","in",["trialing","active"])),(snapshot)=>{
      const suscripcionesActivas = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setSuscripciones(suscripcionesActivas);
    })

    return unsubscribeSuscripciones;
  }, [user]);

  const crearSesionCheckout = async (priceId, productName) => {
    if (!user) {
      swal('Error', 'Debes iniciar sesión para realizar una compra', 'error');
      return;
    }

    // Verificar si ya tiene una suscripción activa
    if (suscripciones.length > 0) {
      swal('Información', 'Ya tienes una suscripción activa. Puedes gestionarla desde el portal del cliente.', 'info');
      return;
    }

    setProcesandoPago(true);

    try {
      const docRef = await addDoc(collection(db,"customers",user.uid,"checkout_sessions"),{
        price: priceId,
        success_url: window.location.origin + '/sistema-pagos?success=true',
        cancel_url: window.location.origin + '/sistema-pagos?canceled=true',
        allow_promotion_codes: allowPromotionCodes,
      })

      const unsubscribe = onSnapshot(docRef,(snap)=>{
        const data = snap.data();
        if (data?.error) {
          setProcesandoPago(false);
          swal('Error', `Error al procesar el pago: ${data.error.message}`, 'error');
        }
        if (data?.url) {
          // Tenemos una URL de Stripe Checkout, redirigir
          window.location.assign(data.url);
        }
      })

    } catch (error) {
      setProcesandoPago(false);
      console.error('Error creando sesión de checkout:', error);
      swal('Error', 'Error al iniciar el proceso de pago', 'error');
    }
  };

  // Función para verificar si ya tiene una suscripción activa
  const yaEstaSuscrito = () => {
    return suscripciones.length > 0;
  };

  // Función para obtener el tipo de suscripción activa
  const obtenerSuscripcionActiva = (priceId) => {
    return suscripciones.find(sub => 
      sub.price && sub.price.id === priceId
    );
  };

  const abrirPortalCliente = async () => {
    console.log(suscripciones)
    if (!user) return;

    try {
      const functionRef = window.firebase
        .app()
        .functions('us-central1')
        .httpsCallable('ext-firestore-stripe-payments-createPortalLink');
      
      const { data } = await functionRef({
        returnUrl: window.location.origin,
        locale: "es", // Español
      });

      window.location.assign(data.url);
    } catch (error) {
      console.error('Error abriendo portal del cliente:', error);
      swal('Error', 'No se pudo abrir el portal del cliente', 'error');
    }
  };

  const formatearPrecio = (precio) => {
    const amount = precio.unit_amount / 100;
    const currency = precio.currency
    return `$${amount.toLocaleString('es-MX')} ${currency}`;
  };

  const formatearIntervalo = (precio) => {
    if (precio.type === 'one_time') return 'Pago único';
    if (precio.recurring) {
      const { interval, interval_count } = precio.recurring;
      if (interval_count === 1) {
        switch (interval) {
          case 'month': return 'por mes';
          case 'year': return 'por año';
          case 'week': return 'por semana';
          case 'day': return 'por día';
          default: return `por ${interval}`;
        }
      } else {
        switch (interval) {
          case 'month': return `cada ${interval_count} meses`;
          case 'year': return `cada ${interval_count} años`;
          case 'week': return `cada ${interval_count} semanas`;
          case 'day': return `cada ${interval_count} días`;
          default: return `cada ${interval_count} ${interval}`;
        }
      }
    }
    return '';
  };

  if (!user) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-6">
        <Card className="max-w-md w-full">
          <CardBody className="p-8 text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Acceso Requerido</h2>
            <p className="text-gray-600 mb-6">
              Debes iniciar sesión para acceder al sistema de pagos.
            </p>
          </CardBody>
        </Card>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-6">
        <Card className="max-w-md w-full">
          <CardBody className="p-8 text-center">
            <Spinner size="lg" color="primary" className="mb-4" />
            <p className="text-gray-600">Cargando opciones de suscripción...</p>
          </CardBody>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <Card className="mb-8">
          <CardHeader className="flex gap-3 justify-center">
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-2">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                </svg>
              </div>
              <h1 className="text-3xl font-bold text-gray-800">Sistema de Suscripciones</h1>
              <p className="text-gray-600">Elige el plan perfecto para ti</p>
            </div>
          </CardHeader>
        </Card>

        {/* Suscripciones Activas */}
        {suscripciones.length > 0 && (
          <Card className="mb-8 bg-gradient-to-r from-green-500 to-green-600 text-white">
            <CardBody className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-xl font-semibold mb-2">✅ Suscripción Activa</h3>
                  <p className="text-green-100 mb-3">
                    Tienes {suscripciones.length} suscripción(es) activa(s)
                  </p>
                  <div className="space-y-2">
                    {suscripciones.map((sub, index) => 
                    {
                      console.log(sub)
                      return (
                        <div key={sub.id} className="bg-green-400/20 rounded-lg p-3">
                          <div className="flex items-center justify-between">
                            <div>
                              <Chip color="success" variant="flat" size="sm" className="mb-1">
                                {sub.status === 'trialing' ? 'Período de prueba' : 'Activa'}
                              </Chip>
                              {sub.current_period_end && (
                                <p className="text-green-200 text-xs">
                                  Próximo pago: {new Date(sub.current_period_end * 1000).toLocaleDateString('es-MX')}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                      )
                    }
                    )}
                  </div>
                </div>
                <div className="flex flex-col space-y-2">
                  <Button
                    onClick={abrirPortalCliente}
                    color="default"
                    variant="bordered"
                    className="bg-white text-green-600 border-white hover:bg-green-50"
                  >
                    Gestionar Suscripción
                  </Button>
                  <p className="text-green-100 text-xs text-center">
                    No puedes comprar nuevas suscripciones
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>
        )}

        {/* Configuración */}
        <Card className="mb-8">
          <CardBody className="p-6">
            <div className="flex items-center justify-between">
              <span className="font-medium text-gray-700">Permitir códigos promocionales:</span>
              <Switch 
                isSelected={allowPromotionCodes}
                onValueChange={setAllowPromotionCodes}
                color="primary"
              >
                {allowPromotionCodes ? 'Habilitado' : 'Deshabilitado'}
              </Switch>
            </div>
          </CardBody>
        </Card>

        {/* Planes de Suscripción */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {productos.map((producto) => (
            <Card key={producto.id} className="border border-gray-200 hover:shadow-lg transition-shadow">
              <CardHeader className="pb-2">
                <div className="flex flex-col w-full">
                  <h3 className="text-xl font-bold text-gray-800">{producto.name}</h3>
                  {producto.description && (
                    <p className="text-gray-600 text-sm mt-1">{producto.description}</p>
                  )}
                </div>
              </CardHeader>
              <CardBody className="pt-2">
                <div className="space-y-4">
                  {producto.prices.map((precio) => (
                    <div key={precio.id} className="border border-gray-100 rounded-lg p-4">
                      <div className="flex items-center justify-between mb-2">
                        <div className="text-2xl font-bold text-blue-600">
                          {formatearPrecio(precio)}
                        </div>
                        <div className="text-sm text-gray-500">
                          {formatearIntervalo(precio)}
                        </div>
                      </div>
                      
                      {precio.trial_period_days && !yaEstaSuscrito() && (
                        <div className="mb-3">
                          <Chip color="warning" size="sm" variant="flat">
                            {precio.trial_period_days} días de prueba gratis
                          </Chip>
                        </div>
                      )}

                      {/* Mostrar si ya está suscrito a este precio específico */}
                      {obtenerSuscripcionActiva(precio.id) && (
                        <div className="mb-3">
                          <Chip color="success" size="sm" variant="flat">
                            ✅ Ya tienes esta suscripción
                          </Chip>
                        </div>
                      )}

                      {/* Mostrar si tiene otra suscripción activa */}
                      {yaEstaSuscrito() && !obtenerSuscripcionActiva(precio.id) && (
                        <div className="mb-3">
                          <Chip color="warning" size="sm" variant="flat">
                            ⚠️ Ya tienes una suscripción activa
                          </Chip>
                        </div>
                      )}

                      <Button
                        onPress={() => crearSesionCheckout(precio.id, producto.name)}
                        color={yaEstaSuscrito() ? "default" : "primary"}
                        variant={yaEstaSuscrito() ? "bordered" : "solid"}
                        className="w-full"
                        isLoading={procesandoPago}
                        disabled={procesandoPago || yaEstaSuscrito()}
                      >
                        {yaEstaSuscrito() ? 
                          (obtenerSuscripcionActiva(precio.id) ? 
                            'Ya Suscrito' : 
                            'Tienes Otra Suscripción'
                          ) : 
                          (precio.type === 'one_time' ? 'Comprar Ahora' : 'Suscribirse')
                        }
                      </Button>
                    </div>
                  ))}
                </div>
              </CardBody>
            </Card>
          ))}
        </div>

        {productos.length === 0 && (
          <Card>
            <CardBody className="p-12 text-center">
              <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-700 mb-2">No hay planes disponibles</h3>
              <p className="text-gray-500">Los planes de suscripción aparecerán aquí cuando estén configurados.</p>
            </CardBody>
          </Card>
        )}

        {/* Información de Seguridad */}
        <div className="grid md:grid-cols-2 gap-6 mt-8">
          <Card className="bg-gradient-to-r from-blue-500 to-blue-600 text-white">
            <CardBody className="p-6">
              <h3 className="text-xl font-semibold mb-2">🔒 Procesamiento Seguro</h3>
              <p className="text-blue-100">
                Pagos seguros con Stripe. Certificación PCI DSS y encriptación SSL.
              </p>
            </CardBody>
          </Card>
          
          <Card className="bg-gradient-to-r from-purple-500 to-purple-600 text-white">
            <CardBody className="p-6">
              <h3 className="text-xl font-semibold mb-2">⚡ Activación Instantánea</h3>
              <p className="text-purple-100">
                Tu suscripción se activa inmediatamente después del pago exitoso.
              </p>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default SistemaPagos; 